/** Page sizes for the Knowledge screen. The list routes cap a page at 100. */

export const MEMORY_PAGE = 50;
export const DOC_RECENT = 4;
export const DOC_PAGE = 20;
export const PAGE_CAP = 100;
export const SEARCH_WAIT = 300;

export function countsOf(result) {
  const counts = (result && result.counts) || {};
  return {
    fact: asNum(counts.fact),
    decision: asNum(counts.decision),
    todo: asNum(counts.todo),
    instruction: asNum(counts.instruction),
  };
}

export function mergeRows(current, incoming) {
  const seen = new Set((current || []).map((row) => row && row.id));
  const extra = [];
  for (const row of incoming || []) {
    if (!row || seen.has(row.id)) continue;
    seen.add(row.id);
    extra.push(row);
  }
  return (current || []).concat(extra);
}

export function copyMemory(memory) {
  const next = { ...memory };
  delete next.embedding;
  return next;
}

export function upsertRow(rows, memory) {
  const next = copyMemory(memory);
  const rest = (rows || []).filter((row) => row.id !== next.id);
  rest.unshift(next);
  return rest;
}

export function upsertCounted(list, counts, key, memory) {
  const existed = (list.rows || []).some((row) => row.id === memory.id);
  list.rows = upsertRow(list.rows, memory);
  if (!existed) {
    list.total = asNum(list.total) + 1;
    if (counts && key) counts[key] = asNum(counts[key]) + 1;
  }
}

export function dropCounted(list, counts, key, id) {
  const rows = list.rows || [];
  if (!rows.some((row) => row.id === id)) return false;
  list.rows = rows.filter((row) => row.id !== id);
  list.total = Math.max(0, asNum(list.total) - 1);
  if (counts && key) counts[key] = Math.max(0, asNum(counts[key]) - 1);
  return true;
}

export function later(fn, wait) {
  let timer = 0;
  return function delayed(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
}

function asNum(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}
